<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  padding: 0px;
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue